module.exports = __webpack_public_path__ + "img/swipeBox.b0b519ed.svg";